import DetailSpokenDialogueView from "@features/tools/view/spoken-dialogue-view/detail-spoken-dialogue-view";

const DetailSpokenDialogue = () => {
  return <DetailSpokenDialogueView />;
};

export default DetailSpokenDialogue;
